import { Dialog, DialogFooter, DialogType, PrimaryButton, DefaultButton } from "@fluentui/react";
import { t } from "i18next";
import React from "react";

interface DialogRecoveredDataProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const DialogRecoveredData: React.FC<DialogRecoveredDataProps> = ({ isOpen, onConfirm, onCancel }) => (
  <Dialog
    hidden={!isOpen}
    dialogContentProps={{
      type: DialogType.normal,
      title: t("¡Ups! Encontramos algo tuyo"),
    }}
    modalProps={{
      isBlocking: true,
    }}
    onDismiss={onCancel}
  >
    <div>
      {t("Parece que dejaste información sin guardar la última vez. ¿Quieres continuar desde donde lo dejaste o empezar de cero?")}
      <br />
    </div>

    <DialogFooter>
      <PrimaryButton onClick={onConfirm} text={t("Continuar")} />
      <DefaultButton onClick={onCancel} text={t("Cancelar")} />
    </DialogFooter>
  </Dialog>
);

export default DialogRecoveredData;